var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Observable, Scope } from 'wdc-cube';
/**
 * O scope de um place de CONCEITO - aquele que existe para dar casa a um assunto,
 * e nao para desenhar.
 *
 * Um place de conceito e passagem: "Colaboradores" nao e uma tela, sao duas - a
 * listagem e o detalhe -, e o que elas dividem (o filtro, a ordenacao, a pagina)
 * pertence ao assunto, nao a nenhuma das duas. O apresentador do conceito guarda
 * isso, publica no endereco e reencaminha quem para nele para a composicao padrao.
 *
 * ## Por que isso importa
 *
 * Sem o conceito, o detalhe tem de ser FILHO da listagem para herdar os filtros -
 * e ai a listagem esta viva toda vez que o detalhe abre, mesmo sem aparecer. Cada
 * lista precisava entao de um desvio escrito a mao ("se nao sou o ultimo, nao
 * desenho nem busco, MAS ainda atualizo o estado de onde sai o endereco"), e as
 * tres listas do painel escreviam isso de tres jeitos diferentes. O invariante era
 * frageil e nao estava em lugar nenhum a nao ser num comentario.
 *
 * Com o conceito no caminho, listagem e detalhe sao IRMAOS: nenhum e ancestral do
 * outro, so o que foi pedido e montado, e o estado comum tem um dono unico.
 *
 * ## Quando um conceito usa esta classe, e quando nao usa
 *
 * A pergunta e uma so: **o conceito tem ponto de aterrissagem?**
 *
 * NAO TEM - usa esta classe. As telas do assunto se SUBSTITUEM, nenhuma delas e "o
 * lugar", e parar no conceito nao e um estado que se possa desenhar. E o caso de
 * `collaborators` e de `monitoring`: a listagem e o detalhe ocupam a mesma area, e
 * quem para no conceito e reencaminhado para a composicao padrao. As telas ficam
 * IRMAS, e abrir uma nao mantem a outra viva.
 *
 * TEM - nao usa esta classe. O conceito tem scope e view proprios, como qualquer
 * tela, e o que vem depois dele e desenhado POR CIMA. E o caso de `companies`: a
 * listagem nunca sai da tela, entao ela e a aterrissagem do conceito, e os dialogos
 * de editar e confirmar sao filhos - precisam da lista viva atras deles. Aninhar
 * ali nao e falta de simetria com `collaborators`, e a mesma regra respondendo
 * diferente. O `hub` e a variante parcial: recusa ser terminal, mas desenha a casca.
 *
 * ## Um scope so para todos
 *
 * Nao ha o que observar: um place de passagem nao tem view. A classe existe porque
 * `CubePresenter` exige um scope, e uma por conceito seriam N classes vazias
 * identicas.
 */
let ConceptScope = class ConceptScope extends Scope {
};
ConceptScope = __decorate([
    Observable
], ConceptScope);
export { ConceptScope };
//# sourceMappingURL=concept.scope.js.map